export default function documentLoaded() {
    return new Promise(resolve => {
        if (document.readyState === 'complete') {
            resolve()
        }
        window.addEventListener('load', () => resolve())
    })
}
